export default __webpack_public_path__ + "static/media/03.d5a28c2e.png";